export default "__VITE_ASSET__055876a2__"